import { Box, Typography } from '@astro-ui/components'
import icLabelUsia from 'assets/images/icLabelUsia.svg'
import QRCode from 'react-qr-code'
import styled from 'styled-components'

import { receiptSize } from './layout'

type BodyV2PropsType = {
  data: {
    order_customer_address: {
      customer_name: string
      customer_address_label: string
      customer_address_place: string
      customer_address_detail: string
      customer_address_description: string
    }
    is_twenty_one_plus: boolean
    order_id: string
    order_packages: {
      packageId: string
    }[]
    order_invoice: string
    stagingArea?: string
    order_type?: string
    order_grab?: {
      grab_booking_id: string
    }
  }
  packageOrderNumber?: string
  packageId: string
  orderPackage?: {
    packageId: string
    packageLabel?: string
  }
}

const BodyV2 = ({ data, packageOrderNumber, packageId, orderPackage }: BodyV2PropsType) => {
  const {
    order_customer_address: {
      customer_name,
      customer_address_label,
      customer_address_detail,
      customer_address_description,
      customer_address_place,
    },
    is_twenty_one_plus,
    order_id,
    order_packages,
    stagingArea,
    order_type,
    order_grab,
  } = data
  const uniquePID = packageId.split('-')[packageId.split('-').length - 1]
  const hasLabel = customer_address_label || customer_address_detail || customer_address_place

  const CustomerInformation = () => (
    <Box
      display="flex"
      flexDirection="column"
      width="50%"
      minWidth={0}
      overflow="hidden"
      borderRight="1px dashed black"
      gap={receiptSize(8)}
      paddingRight={receiptSize(22)}
    >
      <Box>
        <TypographyWithClamp
          fontSize={receiptSize(46)}
          fontWeight={900}
          lineHeight={1.1}
          lineClamp={2}
        >
          {order_type !== 'GRAB_MART' ? customer_name : order_grab?.grab_booking_id}
        </TypographyWithClamp>
        <TypographyWithClamp
          fontSize={receiptSize(36)}
          fontWeight={600}
          lineHeight={1.2}
          lineClamp={1}
        >
          #{order_id}
        </TypographyWithClamp>
      </Box>
      {is_twenty_one_plus && (
        <Box display="flex" flexDirection="row" gap={receiptSize(8)} alignItems="center">
          <img
            src={icLabelUsia}
            alt="icLabelUsia"
            style={{ width: receiptSize(42), height: 'auto' }}
          />
          <Typography fontSize={receiptSize(18)} fontWeight={600} lineHeight={1.25}>
            Paket hanya bisa diterima sesuai nama pembeli
          </Typography>
        </Box>
      )}
      {hasLabel && order_type !== 'GRAB_MART' && (
        <Box>
          <Typography fontSize={receiptSize(18)} fontWeight={900} lineHeight={1.25}>
            {customer_address_label?.split(',')[0].toUpperCase() || 'ALAMAT PENERIMA'}
          </Typography>
          <TypographyWithClamp
            fontSize={receiptSize(18)}
            fontWeight={600}
            lineHeight={1.25}
            lineClamp={3}
          >
            {customer_address_place}, {customer_address_detail}
          </TypographyWithClamp>
        </Box>
      )}
      {customer_address_description && (
        <Box>
          <Typography fontSize={receiptSize(18)} fontWeight={900} lineHeight={1.25}>
            DETAIL ALAMAT
          </Typography>
          <TypographyWithClamp
            fontSize={receiptSize(18)}
            fontWeight={600}
            lineHeight={1.25}
            lineClamp={3}
          >
            {customer_address_description}
          </TypographyWithClamp>
        </Box>
      )}
    </Box>
  )

  const OrderInformation = () => (
    <Box
      display="flex"
      flexDirection="column"
      width="50%"
      minWidth={0}
      overflow="hidden"
      gap={receiptSize(8)}
      paddingLeft={receiptSize(32)}
    >
      <Box
        padding={receiptSize(5)}
        paddingY={receiptSize(0)}
        borderRadius={receiptSize(8)}
        border="1px solid black"
        width="fit-content"
      >
        <Typography fontSize={receiptSize(26)} fontWeight={900}>
          {`${packageOrderNumber} / ${order_packages.length}`}
        </Typography>
      </Box>
      <Box>
        <Typography
          fontSize={receiptSize(20)}
          fontWeight={800}
          lineHeight={1.25}
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {orderPackage?.packageLabel || '-'}
        </Typography>
      </Box>
      <Box width={receiptSize(200)} height={receiptSize(200)} flexShrink={0}>
        <QRCode value={packageId || data.order_invoice} style={{ width: '100%', height: '100%' }} />
      </Box>
      <Box display="flex" flexDirection="column" gap={receiptSize(8)}>
        <Typography fontSize={receiptSize(20)} fontWeight={700} lineHeight={1.25}>
          Kode QR: {uniquePID}
        </Typography>

        {stagingArea && (
          <Box borderTop="0.5px solid black" pt="4px" mt="2px" width="fit-content">
            <TypographyWithClamp
              fontSize={receiptSize(20)}
              fontWeight={700}
              lineHeight={1.25}
              lineClamp={1}
            >
              Staging Area: {stagingArea}
            </TypographyWithClamp>
          </Box>
        )}
      </Box>
    </Box>
  )

  return (
    <Box
      display="flex"
      flexDirection="row"
      padding={receiptSize(16)}
      border="1px solid black"
      borderRadius={receiptSize(12)}
      minHeight={0}
      overflow="hidden"
    >
      <CustomerInformation />
      <OrderInformation />
    </Box>
  )
}

const TypographyWithClamp = styled(Typography)<{ lineClamp?: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lineClamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export default BodyV2
